'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = require('jss-theme-reactor');

var _typography = require('../styles/typography');

var _PropTypes = require('../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _Menu = require('../Menu');

var _Menu2 = _interopRequireDefault(_Menu);

var _fuse = require('fuse.js');

var _fuse2 = _interopRequireDefault(_fuse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var createFuse = function createFuse() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var caseSensitive = props.caseSensitive,
      children = props.children,
      distance = props.distance,
      _props$indices = props.indices,
      indices = _props$indices === undefined ? [] : _props$indices,
      location = props.location,
      minMatchCharLength = props.minMatchCharLength,
      shouldSort = props.shouldSort,
      threshold = props.threshold,
      tokenize = props.tokenize;

  return new _fuse2['default'](_react.Children.toArray(children), {
    keys: indices.map(function (k) {
      return 'props.' + k;
    }),
    includeMatches: true,
    includeScore: true,
    caseSensitive: caseSensitive,
    distance: distance,
    location: location,
    minMatchCharLength: minMatchCharLength,
    shouldSort: shouldSort,
    threshold: threshold,
    tokenize: tokenize
  });
};

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('InputDataList', function (theme) {
  return {
    root: {},
    closed: {
      position: 'absolute',
      width: '1px',
      padding: 0,
      overflow: 'hidden',
      clip: 'rect(0, 0, 0, 0)',
      whiteSpace: 'nowrap',
      border: 0
    },
    popover: {
      position: 'fixed',
      marginTop: theme.variables.borderWidthFocused
    }
  };
});

var InputDataList = (_temp2 = _class = function (_Component) {
  _inherits(InputDataList, _Component);

  function InputDataList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InputDataList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InputDataList.__proto__ || Object.getPrototypeOf(InputDataList)).call.apply(_ref, [this].concat(args))), _this), _this.renderItem = function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          child = _ref2.item;

      var key = child.props.value ? { key: child.props.value } : {};

      return _react2['default'].cloneElement(child, Object.assign({}, key, child.props));
    }, _this.fuse = createFuse(_this.props), _this.getValue = function (element) {
      var el = element || _this.getContentAnchorEl();
      return el.hasAttribute('value') ? el.getAttribute('value') : el.textContent;
    }, _this.handleSelectItem = function (e) {
      var onSelectItem = _this.props.onSelectItem;

      onSelectItem(_this.getValue(e.target));
    }, _this.getContentAnchorEl = function () {
      return _this.menu.getContentAnchorEl();
    }, _this.isDirty = function () {
      return _this.props.value && _this.props.value.length > 0;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InputDataList, [{
    key: 'shouldUpdateFuse',
    value: function () {
      function shouldUpdateFuse(props) {
        var _this2 = this;

        var keys = ['indices', 'minMatchCharLength', 'shouldSort', 'threshold'];
        return !keys.every(function (k) {
          return props[k] === _this2.props[k];
        });
      }

      return shouldUpdateFuse;
    }()
  }, {
    key: 'shouldUpdateCollection',
    value: function () {
      function shouldUpdateCollection(props) {
        var _this3 = this;

        var keys = ['children'];
        return !keys.every(function (k) {
          return props[k] === _this3.props[k];
        });
      }

      return shouldUpdateCollection;
    }()
  }, {
    key: 'componentWillUpdate',
    value: function () {
      function componentWillUpdate(props) {
        var updateFuse = this.shouldUpdateFuse(props);
        var updateCollection = this.shouldUpdateCollection(props);

        if (updateFuse) {
          this.fuse = createFuse(props);
          return;
        }
        if (updateCollection) this.fuse.setCollection(_react.Children.toArray(props.children));
      }

      return componentWillUpdate;
    }()
  }, {
    key: 'selectItem',
    value: function () {
      function selectItem(element) {
        var el = element || this.getContentAnchorEl();
        if (el) el.focus();
      }

      return selectItem;
    }()
  }, {
    key: 'selectNextItem',
    value: function () {
      function selectNextItem(element) {
        var el = element || this.getContentAnchorEl();
        if (el.nextElementSibling) el.nextElementSibling.focus();
      }

      return selectNextItem;
    }()
  }, {
    key: 'selectPreviousItem',
    value: function () {
      function selectPreviousItem(element) {
        var el = element || this.getContentAnchorEl();
        if (el.previousElementSibling) el.previousElementSibling.focus();
      }

      return selectPreviousItem;
    }()
  }, {
    key: 'search',
    value: function () {
      function search(value) {
        var children = this.fuse.search(value);

        return children.length !== 0 ? children : _react.Children.toArray(this.props.children).map(function (item) {
          return {
            item: item,
            matches: []
          };
        });
      }

      return search;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this4 = this;

        var _props = this.props,
            anchorEl = _props.anchorEl,
            bindEl = _props.bindEl,
            caseSensitive = _props.caseSensitive,
            childrenProp = _props.children,
            classNameProp = _props.className,
            Menu = _props.component,
            distance = _props.distance,
            indices = _props.indices,
            MenuItemProp = _props.itemComponent,
            location = _props.location,
            minMatchCharLength = _props.minMatchCharLength,
            onSelectItem = _props.onSelectItem,
            open = _props.open,
            shouldSort = _props.shouldSort,
            threshold = _props.threshold,
            tokenize = _props.tokenize,
            value = _props.value,
            props = _objectWithoutProperties(_props, ['anchorEl', 'bindEl', 'caseSensitive', 'children', 'className', 'component', 'distance', 'indices', 'itemComponent', 'location', 'minMatchCharLength', 'onSelectItem', 'open', 'shouldSort', 'threshold', 'tokenize', 'value']);

        var style = {};

        var classes = this.context.styleManager.render(styleSheet);
        var children = this.search(value).map(this.renderItem);

        var className = (0, _classnames2['default'])(classes.root, _defineProperty({}, classes.closed, !open), classNameProp);

        if (anchorEl) {
          var anchorElOnViewPort = {
            bottom: anchorEl.getBoundingClientRect().top + anchorEl.getBoundingClientRect().height,
            top: window.innerHeight - anchorEl.getBoundingClientRect().top
          };

          var itemList = {
            minPadding: (0, _typography.rhythmByUnit)(2),
            itemHeight: this.menu.menuList.list.getBoundingClientRect().height
          };

          var isOffViewPort = anchorElOnViewPort.bottom + parseInt(itemList.minPadding) + parseInt(itemList.itemHeight) > window.innerHeight;

          if (isOffViewPort) {
            style = {
              bottom: anchorElOnViewPort.top
            };
          } else {
            style = {
              top: anchorElOnViewPort.bottom
            };
          }
        }

        return _react2['default'].createElement(Menu, _extends({
          ref: function () {
            function ref(c) {
              return _this4.menu = c;
            }

            return ref;
          }()
        }, Object.assign({}, props, {
          children: children,
          className: className,
          onSelectItem: this.handleSelectItem,
          popoverClassName: classes.popover,
          popoverProps: { style: style },
          tabIndex: -1
        })));
      }

      return render;
    }()
  }]);

  return InputDataList;
}(_react.Component), _class.propTypes = {
  /**
   * This is the DOM element that will be
   * used to set the position of the menu.
   */
  anchorEl: _PropTypes2['default'].object,
  /**
   * If false, `Menu` won't pass `this.getContentAnchorEl` to `Popover`
   */
  anchorInnerElement: _PropTypes2['default'].bool,
  /**
   * If `true`, the menu is part of an AutoComplete component
   */
  autoComplete: _PropTypes2['default'].bool,
  /**
   * If `true`, the menu will autofocus its contents upon entering
   */
  autoFocus: _PropTypes2['default'].bool,
  /**
   * bindEl: This is the input DOM element that will be associated with the data list.
   */
  bindEl: _PropTypes2['default'].func,
  /**
   * Indicates whether comparisons should be case sensitive.
   */
  caseSensitive: _PropTypes2['default'].bool,
  /**
   * The element or component used for the root node.
   */
  component: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * Menu contents, should be menu items.
   */
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * If `true`, there will be no maxHeight applied
   */
  disableMaxHeight: _PropTypes2['default'].bool,
  /**
   * Determines how close the match must be to the fuzzy location (specified by location).
   */
  distance: _PropTypes2['default'].number,
  /**
   * @ignore
   */
  fullWidth: _PropTypes2['default'].bool,
  /**
   * Child properties to filter results by
   */
  indices: _PropTypes2['default'].arrayOf(_PropTypes2['default'].string),
  /**
   * The element or component used for the first unmatched child.
   */
  itemComponent: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * Determines approximately where in the text is the pattern expected to be found.
   */
  location: _PropTypes2['default'].number,
  /**
   * When set to include matches, only the matches whose length
   * exceeds this value will be returned. (For instance, if you want
   * to ignore single character index returns, set to 2)
   */
  minMatchCharLength: _PropTypes2['default'].number,
  /**
   * Callback fired before the Menu is entering.
   */
  onEnter: _PropTypes2['default'].func,
  /**
   * Callback fired when the Menu is entering.
   */
  onEntering: _PropTypes2['default'].func,
  /**
   * Callback fired when the Menu has entered.
   */
  onEntered: _PropTypes2['default'].func, // eslint-disable-line react/sort-prop-types
  /**
   * Callback fired before the Menu is exiting.
   */
  onExit: _PropTypes2['default'].func,
  /**
   * Callback fired when the Menu is exiting.
   */
  onExiting: _PropTypes2['default'].func,
  /**
   * Callback fired when the Menu has exited.
   */
  onExited: _PropTypes2['default'].func, // eslint-disable-line react/sort-prop-types
  /**
   * Callback function fired when the menu is requested to be closed.
   *
   * @param {event} event The event that triggered the close request
   */
  onRequestClose: _PropTypes2['default'].func,
  /**
   * @ignore
   */
  onSelectItem: _PropTypes2['default'].func,
  /**
   * If `true`, the menu is visible.
   */
  open: _PropTypes2['default'].bool,
  /**
   * Boolean toggling the use of a modal for the menu's popover
   */
  modal: _PropTypes2['default'].bool,
  /**
   * Whether to sort the result list, by score
   */
  shouldSort: _PropTypes2['default'].bool,
  /**
   * At what point does the match algorithm give up. A threshold of
   * `0.0` requires a perfect match (of both letters and location),
   * a threshold of `1.0`` would match anything.
   */
  threshold: _PropTypes2['default'].number,
  /**
   * When true, the algorithm will search individual words and the full string,
   * computing the final score as a function of both. In this case, the threshold,
   * distance, and location are inconsequential for individual tokens, and are thus ignored.
   */
  tokenize: _PropTypes2['default'].bool,
  /**
   * The length of the transition in `ms`, or 'auto'
   */
  transitionDuration: _PropTypes2['default'].oneOfType([_PropTypes2['default'].number, _PropTypes2['default'].string]),
  /**
   * The input value to filter results with
   */
  value: _PropTypes2['default'].string
}, _class.defaultProps = {
  autoComplete: true,
  autoFocus: false,
  caseSensitive: false,
  component: _Menu2['default'],
  distance: 1000,
  indices: ['value', 'children'],
  itemComponent: _Menu.MenuItem,
  location: 1,
  minMatchCharLength: 1,
  modal: false,
  threshold: 0.1,
  tokenize: true
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp2);
exports['default'] = InputDataList;


InputDataList.displayName = 'InputDataList';


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/Input/InputDataList.js
// module id = 638
// module chunks = 32